import React, { lazy, Suspense } from 'react';
import { useAuth } from '@/hooks/useAuth';
import { useMetaDescription } from '@/hooks/useMetaDescription';
import { usePetNotifications } from '@/hooks/usePetNotifications';
import { useVersionCheck } from '@/hooks/useVersionCheck';
import { Toaster } from '@/components/ui/sonner';
import { AppRoutes } from './AppRoutes';

// Lazy load non-critical UI that doesn't need to appear on first paint
const AllNotifications = lazy(() => import('@/components/notifications').then(m => ({ default: m.AllNotifications })));
const DebugLauncher = lazy(() => import('@/components/debug/DebugLauncher').then(m => ({ default: m.DebugLauncher })));
const SystemDebugger = lazy(() => import('@/components/SystemDebugger').then(m => ({ default: m.SystemDebugger })));

export function AppLayout() {
  const { user } = useAuth();
  
  // Initialize app-wide hooks
  useMetaDescription();
  usePetNotifications();
  useVersionCheck();

  if (import.meta.env.DEV) {
    console.log('🔍 AppLayout - User:', user ? 'authenticated' : 'not authenticated');
    console.log('🔍 Current pathname:', window.location.pathname);
  }

  return (
    <>
      <div className="app-container">
        <AppRoutes />
        <Suspense fallback={null}>
          <AllNotifications />
          <DebugLauncher />
          <SystemDebugger />
        </Suspense>
      </div>
      <Toaster
        richColors
        position="top-center"
        closeButton
        style={{ zIndex: 2147483647 }} 
      />
    </>
  );
}
